module.exports = __webpack_public_path__ + "img/game-page.9555007a.jpg";